import React from 'react';
export const JourneySection = () => {
  return <div className="w-full bg-white py-12 px-4 md:px-8" data-id="element-81">
      <div className="max-w-4xl mx-auto" data-id="element-82">
        <h2 className="text-3xl font-bold mb-8" data-id="element-83">
          The Trip That Changed It All
        </h2>
        <div className="flex flex-col md:flex-row-reverse gap-8 mb-8 items-center" data-id="element-84">
          <div className="md:w-1/2" data-id="element-85">
            <p className="text-lg leading-relaxed mb-4" data-id="element-86">
              After graduation, I scraped together enough money to fly to Italy.
              Meeting the jewelers face to face changed everything. I learned
              about design, metals, durability. But more importantly — I got to
              bring that level of quality back home.
            </p>
          </div>
          <div className="md:w-1/2 flex justify-center" data-id="element-87">
            <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/cnkT4NR9Hmv9d3Q8mwUsn7/20250706_0000_Jewelers_Studio_Redesign_remix_01jzey5jrjekmbarvtkc6ympwe.png" alt="Italian jeweler working on FRZN designs in his studio" className="w-full max-w-xs rounded-md shadow-md" data-id="element-88" />
          </div>
        </div>
        <div className="bg-gray-100 p-6 rounded-lg mb-8" data-id="element-89">
          <h3 className="text-2xl font-bold mb-4" data-id="element-90">
            The Small Team With a Big Mission
          </h3>
          <p className="text-lg leading-relaxed" data-id="element-91">
            Today, FRZN is still tight-knit. Some of the same friends who wore
            the first chains with me are now helping me ship out thousands.
            We've stayed locked in on the mission: creating pieces that give you
            presence, pride, and a little edge every time you wear them.
          </p>
        </div>
      </div>
    </div>;
};